<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full mb-2">
                <vs-button v-if="$acl.check('admin')" type="border" color="danger" class="float-right ml-2" @click="deleteShift" icon="delete">{{$t('Delete') | ToUppercase}}</vs-button>
                <vs-button color="primary" class="float-right ml-2" @click="editShift" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
            </div>
            <div class="vx-col w-full mb-2">
                <vx-card :title="$t('ShiftData') |ToUppercase">
                    <table class="userDataTable">
                        <tr>
                            <td class="fontSemibold">{{$t('Name') |ToUppercase}}</td>
                            <td>{{ shift.name }}</td>
                        </tr>
                        <tr>
                            <td class="fontSemibold">{{$t('Day') |ToUppercase}}</td>
                            <td>{{ shift.dayOfWeek}}</td>
                        </tr>
                        <tr>
                            <td class="fontSemibold">{{$t('TimeFrom') |ToUppercase}}</td>
                            <td>{{ shift.timeFrom}}</td>
                        </tr>
                        <tr>
                            <td class="fontSemibold">{{$t('TimeTo') |ToUppercase}}</td>
                            <td>{{ shift.timeTo}}</td>
                        </tr>
                    </table>
                </vx-card>
            </div>
        </div>
        <vs-popup :title="$t('DeleteShiftAlert') |ToUppercase" :active.sync="showDeleteAlert">
            <vs-row vs-justify="center" class="mt-2">
                <vs-button color="primary" type="filled" class="mx-2" @click="showDeleteAlert = false">{{$t('Cancel') |ToUppercase}}</vs-button>
                <vs-button color="danger" type="filled" @click="acceptDeletion">{{$t('Remove') |ToUppercase}}</vs-button>
            </vs-row>
        </vs-popup>
    </div>
</template>
<script>
export default {
    $_veeValidate: {
        validator: "new"
    },
    filters: {
        ToUppercase: function (value) {
        if (!value) return "";
        value = value.toString();
        return value.toUpperCase();
        },
    },
    data() {
        return {
            id: 0,
            shift: {},
            selected: "",
            showDeleteAlert: false,
            hasAcceptedDeletion: false
        };
    },
    methods: {
        async loadData() {
        try {
            let response = await this.$store.dispatch(
            "shift/fetchShift",
            this.id
            );
            this.shift = response.data;
        } catch (error) {
            if (
            error.response.data.code == 404 ||
            error.response.data.code == 500
            ) {
            this.$router.push(
                `../pages/error?error=${error.response.data.error}&code=${
                error.response.data.code
                }&button=${this.$t(
                "BackToUsersButton"
                )}&link=/user/all/`
            );
            }
            this.$vs.notify({
                title: this.$t("Error"),
                text: error.response.data.error,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                time: 3000
            });
        }
        },
        editShift() {
            this.$router.push(`/shift/edit/${this.id}`);
        },
        async acceptDeletion() {
        this.showDeleteAlert = false;
        this.hasAcceptedDeletion = true;
        await this.deleteShift();
        },
        async deleteShift() {
        if (!this.hasAcceptedDeletion) {
            this.showDeleteAlert = true;
            return;
        }

        this.$vs.loading();
        try {
            let result = await this.$store.dispatch(
            "shift/deleteShift",
            this.id
            );
            this.$vs.notify({
            title: this.$t("SuccessfullyRemoved"),
            text: this.$t("UserSuccessfullyRemoved"),
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success"
            });

            setTimeout(() => {
            this.$router.push(`/shift/all`);
            }, 200);
        } catch (error) {
            this.$vs.notify({
            title: this.$t("Error"),
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
            });
        } finally {
            this.$vs.loading.close();
        }
        },
    },
    async created() {
        this.id = this.$route.params.shift_id;
        this.$vs.loading();
        await this.loadData();
        this.$vs.loading.close();
    }
};
</script>
<style>
.fontSemibold {
  font-weight: 600 !important;
}
.userDataTable {
  white-space: nowrap;
}

.userDataTable td:first-child {
  min-width: 160px;
}

.IDImageWrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.userImage {
  max-height: 400px;
}
.userIDImage {
  max-height: 180px;
}
.center {
  justify-content: center;
  display: flex;
  width: 100%;
}

@media (min-width: 768px) {
  .image {
    width: 100%;
    object-fit: contain;
  }
}
.imageWrapper {
  height: 14em;
  overflow: hidden;
  float: left;
}
.image {
  width: 100%;
  object-fit: cover;
}

.success {
  color: black;
  background: rgb(23, 201, 100) !important;
  box-shadow: 0px 15px 40px -10px rgba(23, 201, 100, 0.9);
}
.danger {
  color: black;
  background: rgb(242, 19, 93) !important;
  box-shadow: 0px 15px 40px -10px rgba(242, 19, 93, 0.9);
}
.warning {
  color: black;
  background: rgb(255, 130, 0) !important;
  box-shadow: 0px 15px 40px -10px rgba(255, 130, 0, 0.9);
}
</style>